module.exports = __webpack_public_path__ + "media/images/plano_fundo_admin-58427b6ebbf7bff8b292bebd5d9ee52f.png";